export default {
  title: 'User Management',
  tagline: 'Add users and define roles',
};
